import { Font, Label, Vector, vec } from 'excalibur';
import { ThemePaletteKey, getTheme } from '../themes/theme';
import { HAND_FONT } from '../utils/fonts';

export interface HandLabelOptions {
  name: string;
  text: string;
  pos: Vector;
  size: number;
  tone: ThemePaletteKey;
  anchor?: Vector;
  maxWidth?: number;
}

export class HandLabel extends Label {
  private tone: ThemePaletteKey;

  constructor(options: HandLabelOptions) {
    super({
      name: options.name,
      text: options.text,
      pos: options.pos,
      maxWidth: options.maxWidth,
      font: new Font({ family: HAND_FONT, size: options.size, color: getTheme().palette[options.tone] }),
    });
    this.tone = options.tone;
    this.anchor = options.anchor === undefined ? vec(0.5, 0.5) : options.anchor;
  }

  setTone(tone: ThemePaletteKey): void {
    this.tone = tone;
    this.refreshTheme();
  }

  refreshTheme(): void {
    this.font.color = getTheme().palette[this.tone];
  }
}
